export const filters = {
  analystCount: 'analyst_count',
  beta: 'beta',
  currentDividend: 'current_dividend',
  currentRoa: 'current_ROA',
  currentRoe: 'current_ROE',
  debtEquity: 'debt_equity',
  eps: 'EPS',
  exactAnalystCount: 'exact_analyst_count',
  futureOneYearGrowth: 'future_one_year_growth',
  futureThreeYearGrowth: 'future_three_year_growth',
  futureThreeYearRoe: 'future_three_year_ROE',
  gridVisibleFlag: 'grid_visible_flag',
  currencyDifferentFromExchange: 'currency_different_from_exchange',
  insiderBuying: 'insider_buying',
  intrinsicDiscount: 'intrinsic_discount',
  isEpsLessThanZero: 'is_eps_less_than_zero',
  isFund: 'is_fund',
  marketcap: 'market_cap',
  pastFiveYearGrowth: 'past_five_year_growth',
  pastOneYearGrowth: 'past_one_year_growth',
  pb: 'PB',
  pe: 'PE',
  peg: 'PEG',
  primaryFlag: 'primary_flag',
  sharePrice: 'share_price',
  warningType: 'warning_type',
  upcomingDividend: 'upcoming_div',
  marketCapMovement7d: 'market_cap_movement_7d',
  ownershipProportionIndividualInsiders:
    'ownership_proportion_individual_insiders',
  // company
  risk_score: 'risk_score',
  value_return_7d: 'value_return_7d',
  value_return30d: 'value_return30d',
  value_return90d: 'value_return90d',
  value_return1y_abs: 'value_return1y_abs',
  value_return3y_abs: 'value_return3y_abs',
  value_return5y_abs: 'value_return5y_abs',
  days_since_listing: 'days_since_listing',
  days_since_last_update: 'days_since_last_update',
  shares_outstanding_single_growth_1y: 'shares_outstanding_single_growth_1y',
  //valuation
  analyst_target_discount: 'analyst_target_discount',
  price_to_sales: 'price_to_sales',
  price_to_fcf: 'price_to_fcf',
  value_ev_to_ebitda: 'value_ev_to_ebitda',
  value_ev_to_sales: 'value_ev_to_sales',
  // futures
  future_forward_pe1y: 'future_forward_pe1y',
  future_forward_ps1y: 'future_forward_ps1y',
  future_forward_ev_to_ebitda1y: 'future_forward_ev_to_ebitda1y',
  future_forward_ev_to_sales1y: 'future_forward_ev_to_sales1y',
  revenue_growth_annual: 'revenue_growth_annual',
  revenue_growth_1y: 'revenue_growth_1y',
  // past
  past_revenue_growth5y: 'past_revenue_growth5y',
  past_revenue_growth1y: 'past_revenue_growth1y',
  past_return_on_capital_employed: 'past_return_on_capital_employed',
  past_net_income_margin: 'past_net_income_margin',
  past_ebitda_margin: 'past_ebitda_margin',
  past_earnings_fcf_ratio: 'past_earnings_fcf_ratio',
  // health
  net_debt_to_equity: 'net_debt_to_equity',
  health_current_solvency_ratio: 'health_current_solvency_ratio',
  //dividend
  dividend_yield_future: 'dividend_yield_future',
  dividend_buyback_yield: 'dividend_buyback_yield',
  dividend_total_shareholder_yield: 'dividend_total_shareholder_yield',
  dividend_payment_growth_annual: 'dividend_payment_growth_annual',
  dividend_payout_ratio: 'dividend_payout_ratio',
  dividend_cash_payout_ratio: 'dividend_cash_payout_ratio',
} as const;

export enum filterLabels {
  /** company */
  market_cap = 'Market Cap',
  share_price = 'Share Price',
  beta = '5 year Beta',
  /** valuation */
  intrinsic_discount = 'Value',
  PE = 'PE Ratio',
  PEG = 'PEG Ratio',
  PB = 'PB Ratio',
  exact_analyst_count = 'Analyst Count',
  /** future */
  future_one_year_growth = '1 Year Earnings Growth Estimate',
  future_three_year_growth = '3 Year Earnings Growth Estimate',
  future_three_year_ROE = '3 Year ROE Estimate',
  /** past performance */
  past_five_year_growth = 'Past 5 Year Earnings Growth',
  past_one_year_growth = 'Past 1 Year Earnings Growth',
  current_ROE = 'ROE Ratio',
  current_ROA = 'ROA Ratio',
  EPS = 'EPS',
  /** financial heatlh */
  debt_equity = 'Debt to Equity Ratio',
  /** dividends */
  current_dividend = 'Dividend Yield',
  upcoming_div = 'Upcoming dividend',
  /** management */
  insider_buying = 'Insider Buying Ratio',
  /** other */
  analyst_count = 'Hide companies with low analyst coverage',
  is_fund = "Include ETF's & Funds",
  primary_flag = 'Hide secondary listings',
  warning_type = 'Only show companies with recent price volatility',
  currency_different_from_exchange = 'Show companies with currency different to exchange',
  ownership_proportion_individual_insiders = 'Insider Ownership',
  /** screener update */
  risk_score = 'Risk score',
  value_return_7d = '7 day return',
  value_return30d = '30 day return',
  value_return90d = '90 day return',
  value_return1y_abs = '1 year return',
  value_return3y_abs = '3 year return',
  value_return5y_abs = '5 year return',
  days_since_listing = 'Days since listing',
  days_since_last_update = 'Days since earnings update',
  analyst_target_discount = 'Share price vs analyst price target',
  price_to_sales = 'PS ratio',
  price_to_fcf = 'PFCF ratio',
  value_ev_to_ebitda = 'EV to ebitda',
  value_ev_to_sales = 'EV to sales',
  //
  future_forward_pe1y = 'Forward PE Ratio',
  future_forward_ps1y = 'Forward PS Ratio',
  future_forward_ev_to_ebitda1y = 'Forward EV to Ebitda',
  future_forward_ev_to_sales1y = 'Forward EV to Sales',
  revenue_growth_annual = 'Forecast Revenue Growth',
  revenue_growth_1y = '1 Year Revenue Growth',
  //
  past_revenue_growth5y = 'Annual Revenue Growth',
  past_revenue_growth1y = '1 Year Revenue Growth',
  past_return_on_capital_employed = 'ROCE Ratio',
  past_net_income_margin = 'Profit Margin',
  past_ebitda_margin = 'Ebitda Margin',
  past_earnings_fcf_ratio = 'Earnings to Free Cash Flow Ratio',
  //
  net_debt_to_equity = 'Net Debt to Equity Ratio',
  health_current_solvency_ratio = 'Current Assets to Current Liabilities Ratio',
  //
  dividend_yield_future = 'Forecast Dividend Yield',
  dividend_buyback_yield = 'Buyback Yield',
  dividend_total_shareholder_yield = 'Total Shareholder Yield',
  dividend_payment_growth_annual = 'Dividend Growth',
  dividend_payout_ratio = 'Payout Ratio',
  dividend_cash_payout_ratio = 'Cash Payout Ratio',
}

export enum FilterTypes {
  market = 'market',
  industry = 'industry',
  additional = 'additional',
}

export const API_INFINITY_VALUE = 2147483647;

export enum FILTER_TYPE {
  RANGE = 'range',
  SLIDER = 'slider',
  TOGGLE = 'toggle',
}

const createDropdownOption = (value: string, label: string) => ({
  option: value,
  label,
});

export const orderByDropdownOptions = [
  createDropdownOption(filters.marketcap, filterLabels[filters.marketcap]),
  //
  createDropdownOption('total_score', 'Total Score'),
  createDropdownOption('value_score', 'Value Score'),
  createDropdownOption('future_performance_score', 'Future Score'),
  createDropdownOption('past_performance_score', 'Past Performance Score'),
  createDropdownOption('health_score', 'Health Score'),
  createDropdownOption('dividends_score', 'Dividends Score'),
  //
  createDropdownOption(
    filters.intrinsicDiscount,
    filterLabels[filters.intrinsicDiscount]
  ),
  createDropdownOption(filters.pe, filterLabels[filters.pe]),
  createDropdownOption(filters.pb, filterLabels[filters.pb]),
  createDropdownOption(filters.peg, filterLabels[filters.peg]),
  createDropdownOption(
    filters.futureOneYearGrowth,
    filterLabels[filters.futureOneYearGrowth]
  ),
  createDropdownOption(
    filters.futureThreeYearGrowth,
    filterLabels[filters.futureThreeYearGrowth]
  ),
  createDropdownOption(
    filters.futureThreeYearRoe,
    filterLabels[filters.futureThreeYearRoe]
  ),
  createDropdownOption(
    filters.pastOneYearGrowth,
    filterLabels[filters.pastOneYearGrowth]
  ),
  createDropdownOption(
    filters.pastFiveYearGrowth,
    filterLabels[filters.pastFiveYearGrowth]
  ),
  createDropdownOption(filters.currentRoe, filterLabels[filters.currentRoe]),
  createDropdownOption(filters.currentRoa, filterLabels[filters.currentRoa]),
  createDropdownOption(filters.eps, filterLabels[filters.eps]),
  createDropdownOption(filters.debtEquity, filterLabels[filters.debtEquity]),
  createDropdownOption(
    filters.insiderBuying,
    filterLabels[filters.insiderBuying]
  ),
  createDropdownOption(filters.sharePrice, filterLabels[filters.sharePrice]),
  createDropdownOption(filters.beta, filterLabels[filters.beta]),
  createDropdownOption(filters.analystCount, 'Analyst Coverage'),
  createDropdownOption('name', 'Company name'),
  createDropdownOption('unique_symbol', 'Symbol'),
  createDropdownOption('market_cap_movement_7d', 'Market Movers'),
];

export const SCREENER_RULES_PERSISTED_KEY = 'screener-rules-persisted';
